import { z } from 'zod'

/** Mail-KI-Helfer (#782): the only shape the local model's answer may reach the
 * browser in. Plain text only — the web renders every field as a React text
 * node, never as HTML. */
export const MAIL_ASSIST_LIMITS = {
  summary: 3,
  tasks: 5,
  events: 5,
  line: 200,
  draft: 4000,
} as const

/** Error codes of POST /mail/accounts/:id/messages/:messageId/assist. */
export const MAIL_ASSIST_DISABLED = 'MAIL_AI_DISABLED'
export const MAIL_ASSIST_UNAVAILABLE = 'MAIL_AI_UNAVAILABLE'
export const MAIL_ASSIST_BUSY = 'MAIL_AI_BUSY'

function isRealDate(value: string): boolean {
  const [y, m, d] = value.split('-').map(Number)
  const date = new Date(Date.UTC(y, m - 1, d))
  return date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d
}

export const mailAssistDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .refine(isRealDate, 'invalid date')
export const mailAssistTimeSchema = z.string().regex(/^(?:[01]\d|2[0-3]):[0-5]\d$/)

const line = z.string().trim().min(1).max(MAIL_ASSIST_LIMITS.line)

export const mailAssistTaskSchema = z
  .object({ title: line, due: mailAssistDateSchema.nullable() })
  .strict()

export const mailAssistEventSchema = z
  .object({ title: line, date: mailAssistDateSchema, time: mailAssistTimeSchema.nullable() })
  .strict()

export const mailAssistResultSchema = z
  .object({
    summary: z.array(line).min(1).max(MAIL_ASSIST_LIMITS.summary),
    tasks: z.array(mailAssistTaskSchema).max(MAIL_ASSIST_LIMITS.tasks),
    events: z.array(mailAssistEventSchema).max(MAIL_ASSIST_LIMITS.events),
    replyDraft: z.string().max(MAIL_ASSIST_LIMITS.draft),
  })
  .strict()

export type MailAssistTask = z.infer<typeof mailAssistTaskSchema>
export type MailAssistEvent = z.infer<typeof mailAssistEventSchema>
export type MailAssistResult = z.infer<typeof mailAssistResultSchema>
